import { useState, useEffect,useContext } from 'react'
import { Data, InfoWindow, Marker, MarkerClusterer  } from '@react-google-maps/api';
import LayersContext from '../context/LayersContext';

export default function GeoJsonLayer(props) {
    const layersContext = useContext(LayersContext);
    const module = props.module;
    const geoJsonUrl = module.geoJsonUrl;
    const setLayersOn = props.setLayersOn;
    const geoOptions = module.geoOptions;
    const showPopups = module.geoJsonPopups;

    const title = module.name;
    const [visible, setVisible] = useState(module.defaultOn);
    const [dataLayer, setDataLayer] = useState(null);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [markersData, setMarkersData] = useState([]);

    useEffect(() => {
        if (visible) {
            setLayersOn(layersContext => {
                let newLayersContext = { ...layersContext };
                if(!newLayersContext[title]) {
                  newLayersContext[title] = {enabled:true}
                } else {
                  newLayersContext[title].enabled = true;
                }
                return newLayersContext;
            })
        }
    }, [])

    useEffect(() => {
        if (undefined !== layersContext[title]) {
            const isSelected = layersContext[title].enabled;
            setVisible(isSelected);
        }
    }, [layersContext, title]);

    useEffect(() => {
        if(dataLayer) {
            let style = geoOptions;
            style.visible = visible;
            dataLayer.setStyle(style);
        }
    },[visible,dataLayer])

    const onLoad = data => {
        setDataLayer(data);
        if (geoJsonUrl && title === 'Intermodal Facilities') {
            data.loadGeoJson(geoJsonUrl, null, (features) => {
                const markerDataArr = [];
                // Iterate through the features and add markers to the map
                features.forEach(feature => {
                    // Assuming the feature has a Point geometry
                    const geometry = feature.getGeometry();
                    if (geometry.getType() === 'Point') {
                        const coordinates = geometry.get();
                        const marker = new window.google.maps.Marker({
                            position: {
                                lat: coordinates.lat(),
                                lng: coordinates.lng(),
                            },
                            title: feature.getProperty('Facility_N'), // Adjust this based on your GeoJSON properties
                            description: feature.getProperty('Address'), // Adjust this based on your GeoJSON properties
                            icon: "../mapicons/loadingzones/intermodal.png"
                        });
    
                        // Set the marker as a property of the feature
                        feature.setProperty('marker', marker);

                        const id = `${marker.getTitle()}-${marker.getPosition().toString()}`;
                        markerDataArr.push({
                            id,
                            position: marker.getPosition(),
                            title: marker.getTitle(),
                            description: marker.description,
                            icon: "../mapicons/loadingzones/intermodal.png"
                        });
                    }
                });
                setMarkersData(markerDataArr);
            });

        }else if(geoJsonUrl && title === 'Loading Zones'){
            data.loadGeoJson(geoJsonUrl, null, (features) => {
                const markerDataArr = [];
                // Iterate through the features and add markers to the map
                features.forEach(feature => {
                    // Assuming the feature has a Point geometry
                    const geometry = feature.getGeometry();
                    if (geometry.getType() === 'Point') {
                        const coordinates = geometry.get();
                        const marker = new window.google.maps.Marker({
                            position: {
                                lat: coordinates.lat(),
                                lng: coordinates.lng(),
                            },
                            title: "Loading Zone", // Adjust this based on your GeoJSON properties
                            description: feature.getProperty('Full Address'), // Adjust this based on your GeoJSON properties
                            icon: "../mapicons/loadingzones/truck-loading.png"
                        });
    
                        // Set the marker as a property of the feature
                        //feature.setProperty('marker', marker);
                        const id = `${marker.getTitle()}-${marker.getPosition().toString()}`;
                        markerDataArr.push({
                            id,
                            position: marker.getPosition(),
                            title: marker.getTitle(),
                            description: marker.description,
                            icon: "../mapicons/loadingzones/truck-loading.png"
                        });
                    }
                   
                });
                setMarkersData(markerDataArr);
            });

        }else if(geoJsonUrl){
            data.loadGeoJson(geoJsonUrl);
        }
    }

    const onMarkerClick = (marker) => {
        console.log('geojson marker clicked ', marker );
        setSelectedMarker(marker);
    };

    const onClosePopup = () => {
        setSelectedMarker(null);
    };

    let clusterOptions = {};
    if (title === 'Loading Zones') {
        clusterOptions = { 
            maxZoom: 16,
            styles: [
                {
                  url: '../../mapicons/loadingzones/truck-loading.png',
                  height: 50,
                  width: 50,
                  textSize: 16,
                }
              ]
        };
    } else if (title === 'Intermodal Facilities') {
        clusterOptions = { 
            maxZoom: 16,
            styles: [
                {
                  url: '../../mapicons/loadingzones/intermodal-cluster.png',
                  height: 20,
                  width: 20,
                  textSize: 14,
                  //textColor: '#0856ff',
                }
              ]
        };
    } 

    useEffect(() => {
        if (!visible) {
          setMarkersData([]);
        }
      }, [visible]);

    return (
        <>
        {visible  //&& title !== 'Intermodal Facilities' && title !== 'Loading Zones'
         && <Data onLoad={onLoad}
            style={(feature) => {
                if (title === "Intermodal Facilities" || title === "Loading Zones") {
                    return { visible: false }; // Hide non-clustered markers for these layers
                  }
                return geoOptions
                  
            }}
            onClick={(event) => {
                if (showPopups) {
                  onMarkerClick(event.feature.getProperty('marker'));
                }
              }}
            
         />}
        
        {visible && showPopups && selectedMarker && (
            <InfoWindow
                position={selectedMarker.position}
                onCloseClick={onClosePopup}
            >
                {/* Customize the content of the popup based on your GeoJSON properties */}
                <div style={{ color: '#000000' }}>
                    <h4>{title}</h4>
                    {title !== 'Loading Zones' && <h5>{selectedMarker.title}</h5>}
                    <p>{selectedMarker.description}</p>
                </div>
            </InfoWindow>
        )}
            {/* Render markers via MarkerClusterer if markersData exists */}
      {visible && markersData.length > 0 && showPopups && (
        <MarkerClusterer options={clusterOptions}>
          {clusterer =>
            markersData.map(markerData => (
              <Marker
                key={markerData.id}
                position={markerData.position}
                clusterer={clusterer}
                icon={markerData.icon}
                onClick={() => onMarkerClick(markerData)}
              />
            ))
          }
        </MarkerClusterer>
      )}
        </>
    )

}